package org.solyton.solawi.bid.module.application.data.management

/**
 * Alias for [modals]
 */
val applicationManagementModals by lazy{ modals }

/**
 * Alias for [actions]
 */
val applicationManagementActions by lazy{ actions }
